import { createSlice } from '@reduxjs/toolkit';

import { api } from '../../api';

export const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    loading: false,
    error: null,
    info: {},

    paymentSaving: false,
    paymentError: null,
    paymentDeleteStart: false,
    paymentDeleteError: null,

    tokenCreating: false,
    tokenError: null,
  },
  reducers: {
    profileFetchStart(state) {
      state.loading = true;
      state.info = {};
      state.error = null;
    },
    profileFetchSuccess(state, action) {
      state.loading = false;
      state.info = action.payload;
    },
    profileFetchFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    paymentSaveStart(state) {
      state.paymentSaving = true;
      state.paymentError = false;
    },
    paymentSaveSuccess(state, action) {
      state.paymentSaving = false;
      state.paymentError = false;
      state.info.paymentMethods = action.payload;
    },
    paymentSaveError(state, action) {
      state.paymentSaving = false;
      state.paymentError = action.payload;
    },
    paymentDeleteStart(state) {
      state.paymentDeleteStart = true;
    },
    paymentDeleteSuccess(state, action) {
      state.paymentDeleteStart = false;
      state.info.paymentMethods = action.payload;
    },
    paymentDeleteError(state, action) {
      state.paymentDeleteStart = false;
      state.paymentDeleteError = action.payload;
    },
    tokenCreateStart(state) {
      state.tokenCreating = true;
    },
    tokenCreateSuccess(state, action) {
      state.tokenCreating = false;
      state.info.apiTokens.push(action.payload);
    },
    tokenCreateError(state, action) {
      state.tokenCreating = false;
      state.tokenError = action.payload;
    },
    updateFreeLookups(state, action) {
      state.info.freeAddressLookups = action.payload;
    },
  },
});

export const {
  profileFetchStart, profileFetchSuccess, profileFetchFailed,
  paymentSaveStart, paymentSaveSuccess, paymentSaveError,
  paymentDeleteStart, paymentDeleteSuccess, paymentDeleteError,
  tokenCreateStart, tokenCreateSuccess, tokenCreateError,
  updateFreeLookups,
  passwordUpdateStart, passwordUpdateSuccess, passwordUpdateFailed,
} = profileSlice.actions;

export default profileSlice.reducer;

export const selectLoading = state => state.profile.loading;
export const selectInfo = state => state.profile.info;
export const selectError = state => state.profile.error;
export const selectPaymentSaving = state => state.profile.paymentSaving;
export const selectPaymentError = state => state.profile.paymentError;
export const selectPaymentDeleteStart = state => state.profile.paymentDeleteStart;
export const selectPaymentDeleteError = state => state.profile.paymentDeleteError;
export const selectTokenCreating = state => state.profile.tokenCreating;
export const selectTokenError = state => state.profile.tokenError;

export const fetchProfile = () => async dispatch => {
  dispatch(profileFetchStart());
  try {
    const data = await api('/api/profile');
    const {
      first_name: firstName,
      last_name: lastName,
      email,
      payment_methods: paymentMethods,
      api_tokens: apiTokens,
      free_address_lookups: freeAddressLookups,
      charge_amount: chargeAmount,
      credit,
      iam_username :iamUsername,
      s3_filepath : s3Filepath,
      aws_password : awsPassword,
      s3_url : s3Url
    } = data;

    dispatch(profileFetchSuccess({
      firstName,
      lastName,
      email,
      paymentMethods,
      apiTokens,
      freeAddressLookups,
      chargeAmount,
      credit,
      iamUsername,
      s3Filepath,
      awsPassword,
      s3Url
    }));
  } catch (err) {
    dispatch(profileFetchFailed({
      message: err.message,
      status: err.status,
    }));
  }
};

export const savePaymentInfo = (stripe, cardElement) => async dispatch => {
  dispatch(paymentSaveStart());

  try {
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      dispatch(paymentSaveError(error.message));
    } else {
      const {
        payment_methods: paymentMethods
      } = await api('/api/save_payment_method', { payment_method_id: paymentMethod.id });
      dispatch(paymentSaveSuccess(paymentMethods));
    }
  } catch (e) {
    console.log(e);
    dispatch(paymentSaveError(e.message));
  }
};

export const deletePaymentInfo = (id) => async dispatch => {
  dispatch(paymentDeleteStart());

  try {
    const {
      payment_methods: paymentMethods
    } = await api('/api/delete_payment_method',  { payment_method_id: id });
    dispatch(paymentDeleteSuccess(paymentMethods));
  } catch (e) {
    console.log(e);
    dispatch(paymentDeleteError(e.message));
  }
};

export const createToken = () => async dispatch => {
  dispatch(tokenCreateStart());

  try {
    const {
      token
    } = await api('/api/create_token');
    dispatch(tokenCreateSuccess(token));
  } catch (e) {
    console.log(e);
    dispatch(tokenCreateError(e.message));
  }
};
